import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService, MenuItem } from 'primeng/api';
import { DeviceStatusEnum } from '../../../data/enums/device-status-enum';
import { CommonGlobalService } from '../../../services/common-global.service';
import { LineGraphService } from '../../../services/line-graph.service';
import { availabilityChartColors } from '../../cc-portal/avilability-graph/avilability-graph.component';

@Component({
  selector: 'app-status-history',
  templateUrl: './status-history.component.html',
  styleUrls: ['./status-history.component.scss'],
  providers: [MessageService]
})
export class StatusHistoryComponent implements OnInit {
  lineName: string;
  deviceIPInput: string;
  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 3));
  toDate: Date = new Date();
  currentDeviceIP: string;
  currentDeviceId: number;
  chart: any = {}
  chartOptions: any;
  allIntervals: any[];
  breadItems: MenuItem[];
  minSelectableDate: Date;
  maxSelectableDate: Date;

  values: any[];
  times: any[];

  notExist: boolean = false;

  constructor(private messageService: MessageService, private activatedRoute: ActivatedRoute
    , private lineGraphService: LineGraphService, private location: Location, private commonGlobalService: CommonGlobalService) {
    this.minSelectableDate = new Date(new Date().setMonth(new Date().getMonth() - 3));
    this.maxSelectableDate = new Date();
}

  ngOnInit() {

    this.checkUrlToGetCode();

    this.breadItems = [
      { label: 'Home', routerLink: '/' },
      { label: 'LineDetails', routerLink: '/linedetails/' + this.currentDeviceId },
      { label: 'Line Status Log History' }
    ];
  }

  checkUrlToGetCode() {
    this.activatedRoute.params.subscribe(
      (params) => {
        let tmpid = params["id"];
        //let tmpip = params["ip"];
        if (tmpid) {
          this.currentDeviceId = tmpid;
          this.getDevicePingChangesLogById();
        }
       
      }

    );


  }

  getChangesLogs() {
    if (!this.currentDeviceIP) {
      this.messageService.add({ severity: 'error', summary: 'Select Device First', detail: 'there is no device selected to get its logs' });

    }
    else
      this.getDevicePingChangesLog(this.currentDeviceIP, this.fromDate, this.toDate);
  }

  async getDevicePingChangesLog(deviceIp: string, fromDate: any, toDate: any) {  //deviceId: number
    if (!fromDate) {
      let current = new Date();
      fromDate = (!this.fromDate) ? new Date(current.setDate(current.getDate() - 3)) : this.fromDate;
    }
    if (!toDate)
      toDate = (!this.toDate) ? new Date() : this.toDate;

    let obj: DevicePingFilterDto = { deviceId: 0, deviceIp: deviceIp, fromDate: fromDate, toDate: toDate , pairNumber: null };
    await this.lineGraphService.getDevicePingChangesLogs(obj).subscribe((res: any[]) => {
      if (res.length > 0) {
        this.notExist = false;
        this.allIntervals = res.map((item) => { return { x: this.mapStatus(item.status), y: [new Date(item.from).getTime(), new Date(item.to).getTime()], fillColor: availabilityChartColors.mapStatusColor(item.status) } })
        this.drawStatusRangeBarChart(this.allIntervals /*tempStatusLogs.reverse()*/);
      }
      else {
        this.notExist = true;
        this.messageService.add({ severity: 'warn', summary: 'Devices Changes Log', detail: 'There is no logs for that' });

      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Devices Changes Log', detail: 'Could not retrieve ChangesLog now ..' });
    });
  }

  async getDevicePingChangesLogById() {
    let deviceId = this.currentDeviceId;
    let fromDate = this.fromDate;
    let toDate = this.toDate
    //deviceId: number
    if (!fromDate) {
      let current = new Date();
      fromDate = (!this.fromDate) ? new Date(current.setDate(current.getDate() - 3)) : this.fromDate;
    }
    if (!toDate)
      toDate = (!this.toDate) ? new Date() : this.toDate;


    var toDateAfterOneHour;
    var finalToDate = this.toDate;
    if (this.toDate == new Date()) {
      toDateAfterOneHour = new Date(new Date().setHours(new Date().getHours() + 1));
      finalToDate = toDateAfterOneHour;
    }
    let obj: DevicePingFilterDto = { deviceId: deviceId, deviceIp: "", fromDate: fromDate, toDate: toDate, pairNumber: null };
    await this.lineGraphService.getDevicePingChangesLogs(obj).subscribe((res: any[]) => {
      if (res.length > 0) {
        this.notExist = false;
        this.allIntervals = res.map((item) => { return { x: this.mapStatus(item.status), y: [new Date(item.from).getTime(), new Date(item.to).getTime()], fillColor: availabilityChartColors.mapStatusColor(item.status) } })
        this.drawStatusRangeBarChart(this.allIntervals /*tempStatusLogs.reverse()*/);
      }
      else {
        this.notExist = true;
        this.messageService.add({ severity: 'warn', summary: 'Devices Changes Log', detail: 'There is no logs for this Line ' });

      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Devices Changes Log', detail: 'Could not retrieve ChangesLog now' });
    });
  }
  

  GetTrafficData(upDownData: any[]) {
    let valuess = [];
    let timess = [];

    for (var i = 0; i < upDownData?.length; i++) {
      timess.push((upDownData[i].timedDateTime));
      valuess.push(upDownData[i].statusInt);

    }
    if (upDownData[0]?.length == 0) {
      valuess.push[0];


    }
    let inOutData = { inTraffic: valuess, readingTime: timess };
    return inOutData;
  }

  mapStatus(status) {
    //if (status == 2) status = 0;
    //const indexOfS = Object.values(DeviceStatusEnum).indexOf('S' as unknown as DeviceStatusEnum);

    const key = Object.values(DeviceStatusEnum)[status];
    return key;

  }

  async drawStatusChart(logs: any[]) {
    //await this.getStatusInterval(logs);
    let logs2 = logs;
    let intervalsss = this.allIntervals;
    this.destroyChartEvent();
    this.chartOptions = {
      series: [
        {
          data:
            this.allIntervals
        }
      ],
      chart: {
        height: 350,
        type: "RangeBar"

      },
      plotOptions: {
        bar: {
          
          horizontal: true,
          barHeight: '2%'
        }
      },
      tooltip: {
        y: {
          title: {
            formatter: function (value1, value2) {
              let time = new Date(logs[value2.dataPointIndex].from);
              let hours = time.getHours().toString(); if (hours.length == 1) hours = "0" + hours;
              let minutes = time.getMinutes().toString(); if (minutes.length == 1) minutes = "0" + minutes;
              return hours + ":" + minutes;
            }
          }

        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }, yaxis: {
          lines: {
            show: true
          }
        },
        row: {
          colors: ["#f3f4f5", "#fff"],
          opacity: 1
        }
      }
    };

    this.chart = new ApexCharts(document.querySelector("#status-chart"), this.chartOptions);
    this.chart.render();
  }

  drawStatusRangeBarChart(logs: any[]) {

    this.destroyChartEvent();
    this.chartOptions = {
      series: [
        {
          data: logs
        }
      ],
      chart: {
        height: 350,
        type: "rangeBar"
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: 30
        }
      },
      tooltip: {
        y: {
          title: {

            formatter: function (value1, value2) {
              //let starttime = new Date(logs[value2.dataPointIndex].y[0]);
              let starttime = new Date( value2.start);
              let starthours = starttime.getHours().toString(); if (starthours.length == 1) starthours = "0" + starthours;
              let startminutes = starttime.getMinutes().toString(); if (startminutes.length == 1) startminutes = "0" + startminutes;

              let endtime = new Date(value2.end);
              let endhours = endtime.getHours().toString(); if (endhours.length == 1) endhours = "0" + endhours;
              let endminutes = endtime.getMinutes().toString(); if (endminutes.length == 1) endminutes = "0" + endminutes;
              //return hours + ":" + minutes;
              //return time;
              let tooltip = 'From ' + starthours + ':' + startminutes + ' To ' + endhours + ':' + endminutes;

              return tooltip;
            }
          }

        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }, yaxis: {
          lines: {
            show: true
          }
        },
        row: {
          //colors: ["#f3f4f5", "red"],
          opacity: 1
        }
      }
    };

    this.chart = new ApexCharts(document.querySelector("#status-chart"), this.chartOptions);
    this.chart.render();
  }



  destroyChartEvent() {
    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }
  }

  drawWeek() {
    let today = new Date();
    today.setDate(today.getDate() - 7);
    this.fromDate = new Date(today);
    this.getDevicePingChangesLogById();
  }

  drawMonth() {
    let today = new Date();
    today.setDate(today.getDate() - 30);
    this.fromDate = new Date(today);
    this.getDevicePingChangesLogById();
  }


}
export class DevicePingFilterDto {
  deviceId?: number;
  deviceIp?: string;
  fromDate: Date;
  toDate: Date;
  pairNumber: number;
}
